import { isValid, format } from "date-fns";
import { de as LocaleDE } from "date-fns/locale";

export const MONTHS = [
	"Januar",
	"Februar",
	"März",
	"April",
	"Mai",
	"Juni",
	"Juli",
	"August",
	"September",
	"Oktober",
	"November",
	"Dezember",
];

export const FORMAT = "dd.MM.yyyy";
const parseRegex = /(\d{1,2})\.(\d{1,2}).(\d{4})/;

export function parseDate(
	input: string | Date | undefined | null
): Date | undefined {
	if (!input) return undefined;

	if (typeof input === "object") {
		// it's probably a Date
		return input;
	}

	const matches = input.match(parseRegex);
	if (!matches) return undefined;

	const parsed = new Date(matches[3] + "-" + matches[2] + "-" + matches[1]);

	if (isValid(parsed)) {
		return parsed;
	}
	return undefined;
}
export function formatDate(date: Date | null, formatString: string = FORMAT) {
	if (!date) return "-";
	if (!isValid(date)) return "-";
	return format(date, formatString, { locale: LocaleDE });
}
